// Generated by scripts/update-seeq-icons.js from src/svg/seeq/mid-tree.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcMidTree = {
  prefix: 'fak',
  iconName: 'mid-tree' as IconName,
  icon: [
    834,
    1024,
    [],
    'e9c8',
    'M699.6 693.7h-82.4v-147.6h-200s0 0 0 0h-199.8l0.6 145.2-82.4 0.5-0.8-186.6c0-11 4.2-21.6 11.9-29.3s18.3-12.1 29.2-12.1h199.8l0.3-116.8 82.3 0.3-0.2 116.6h200.2s0 0 0 0c10.9 0 21.4 4.3 29.2 12s12 18.2 12 29.2v188.8zM352 985.9v-275.8c0-21-17-38.1-38.1-38.1h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1zM834.4 985.9v-275.8c0-21-17-38.1-38.1-38.1h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1zM555.1 0h-275.8c-21 0-38.1 17-38.1 38.1v275.8c0 21 17 38.1 38.1 38.1h275.8c21 0 38.1-17 38.1-38.1v-275.8c0-21-17-38.1-38.1-38.1zM523.9 282.7h-213.5v-213.5h213.5v213.5z',
  ],
} satisfies IconDefinition;
